import { sendEmail } from "../TOOLS/Queries"

export const createErrorMessage = (error: any) => {
    
    let emailProps: any = 'homalyzona';
    let emailData: any = { to: 'szempontstudio@gmail.com', subject: 'HIBA a 4s2000 szimulátor oldalon!!!', text: error};
    sendEmail(emailProps, emailData)
    .then(response => { })
    .catch(err => { console.log(`SENDEMAIL: ${err.message}`)})

   
}





